import * as React from "react";
import {Col, Row} from "react-bootstrap";
import {KContainer, KSpace} from "@kopjra/uikit";
import {Stats} from "./Stats.tsx";
import {Acquisitions} from "./Acquisitions.tsx";

export const SessionArea: React.FC = () => {
    return (
        <KContainer>
            <KSpace/>
            <Row>
                <Col xs={12}><Stats/></Col>
            </Row>
            <KSpace spaces={3}/>
            <Row>
                <Col xs={12}><Acquisitions reduced={true}/></Col>
            </Row>
        </KContainer>
    );
};